import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = { class: "space-y-2" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-6 md:grid-cols-5" }
const _hoisted_6 = { class: "mb-1 font-semibold" }
const _hoisted_7 = { class: "mb-1 font-semibold" }
const _hoisted_8 = { class: "mb-1 font-semibold" }
const _hoisted_9 = { class: "whitespace-pre-wrap break-words" }
const _hoisted_10 = { class: "flex justify-end px-4 sm:px-0" }

import { toastServiceError } from '@/services';
import ScriptService from '@/services/api/ScriptService';
import { useUiStore } from '@/stores';
import { Permission, ScriptModel } from '@/types';
import { computed, ref, Ref } from 'vue';
import { useRoute } from 'vue-router';

const JQUERY_URL = 'https://code.jquery.com/jquery-2.1.3.min.js';
const JQUERY_UI_URL = 'https://code.jquery.com/ui/1.11.2/jquery-ui.min.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScriptDetailPage',
  setup(__props) {

const route = useRoute();
const uiStore = useUiStore();

const script: Ref<ScriptModel | undefined> = ref(undefined);

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const getScript = async (id: number) => {
    try {
        setLoading(true);
        const { data } = await ScriptService.get<ScriptModel>(id);
        script.value = data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

getScript(Number(route.params.id));

const scripts = computed(() => {
    let scripts = '';

    if (script.value?.includeJquery) {
        const scriptJqueryTag = document.createElement('script');
        scriptJqueryTag.setAttribute('src', JQUERY_URL);
        scripts += scriptJqueryTag.outerHTML + '\n';

        const scriptJqueryUiTag = document.createElement('script');
        scriptJqueryUiTag.setAttribute('src', JQUERY_UI_URL);
        scripts += scriptJqueryUiTag.outerHTML + '\n';
    }

    const scriptUrlTag = document.createElement('script');
    scriptUrlTag.setAttribute('src', script.value?.scriptUrl || '');
    scripts += scriptUrlTag.outerHTML;

    return scripts;
});

const copyToClipboard = () => {
    const textarea = document.createElement('textarea');
    textarea.value = scripts.value;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('script.view.title')), 1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: { name: 'ListScript' } }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_UiButton, {
                "text-variant": "primary",
                "no-border": "",
                "no-shadow": "",
                class: "hover:bg-white/50"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Back')), 1)
                ]),
                _: 1
              })), [
                [_directive_tippy, _ctx.$t('core.actions.Back')]
              ])
            ]),
            _: 1
          }),
          (_ctx.$can(_unref(Permission).EDIT_SCRIPT))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: {
                            name: 'EditScriptById',
                            params: {
                                id: _unref(route).params.id,
                            },
                        },
                class: "block hover:bg-gray-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "primary",
                    "text-variant": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiPanel, { class: "flex px-4 py-2" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('script.labels.clientUrl')), 1),
              _createElementVNode("p", null, _toDisplayString(script.value?.clientUrl), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('script.labels.includeJquery')), 1),
              _createElementVNode("p", {
                class: _normalizeClass([[
                                script.value?.includeJquery
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-red-100 text-red-800',
                            ], "inline-flex rounded-full px-2 text-sm font-semibold leading-5"])
              }, _toDisplayString(script.value?.includeJquery
                                    ? _ctx.$t('core.options.Active')
                                    : _ctx.$t('core.options.Inactive')), 3)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('script.labels.isActive')), 1),
              _createElementVNode("p", {
                class: _normalizeClass([[
                                script.value?.isActive
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-red-100 text-red-800',
                            ], "inline-flex rounded-full px-2 text-sm font-semibold leading-5"])
              }, _toDisplayString(script.value?.isActive
                                    ? _ctx.$t('core.options.Active')
                                    : _ctx.$t('core.options.Inactive')), 3)
            ])
          ])
        ]),
        _: 1
      }),
      (script.value?.isActive)
        ? (_openBlock(), _createBlock(_component_UiPanel, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("pre", _hoisted_9, _toDisplayString(scripts.value), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_UiButton, {
                  variant: "white",
                  "text-variant": "gray-500",
                  class: "mt-4 overflow-auto",
                  onClick: copyToClipboard
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('script.actions.copyToClipboard')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})